import { useMedia } from 'react-use';
import { ButtonSignupLogin } from '@hungryroot/components-customer';
import { useExperiment } from '@hungryroot/experiments';
import { useGetFormattedPromo, useGetPromoData } from '@hungryroot/rest-hooks';
import { BreakpointQueryLarge } from '@hungryroot/tokens';
import { islandRoot } from '../IslandRoot/IslandRoot';
import styles from './PromoMessageActionIsland.module.css';

export const PromoMessageActionIsland = islandRoot(
  ({ className }: { className: string }) => {
    const preAuthCatalogVariant = useExperiment(199);
    const { data: promoData } = useGetPromoData();
    const promoText = useGetFormattedPromo(
      styles.bold,
      promoData,
      styles.promo
    );

    const isDesktop = useMedia(BreakpointQueryLarge, false);

    if (preAuthCatalogVariant === undefined) {
      return null;
    }

    if (preAuthCatalogVariant > 0 && !isDesktop) {
      return (
        <ButtonSignupLogin
          style="accent"
          accentColor="avocado"
          prominence="secondary"
          size="small"
          className={className}
        />
      );
    }

    return promoText;
  }
);
